<div class="card card-custom gutter-b card-fit" data-card="true" >
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Recalls</h3>
        </div>
        <div class="card-toolbar">
            <button type="button" class="btn btn-success btn-sm font-weight-bold" (click)="add()">
                <i class="fas fa-plus icon-sm"></i>Add Recall
            </button>
        </div>
    </div>
<div class="card-body mt-0 py-0 px-5" >  
        <!-- Filter Section -->
        <div class="row mb-4">
            <div class="col-lg-12">
                <div class="d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label-sm mr-3">Filter by:</label>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-outline-primary btn-sm" [class.active]="filterType === 'pet'" (click)="setFilterType('pet')">
                                <input type="radio" name="filterType" value="pet" [checked]="filterType === 'pet'"> Pet
                            </label>
                            <label class="btn btn-outline-primary btn-sm" [class.active]="filterType === 'client'" (click)="setFilterType('client')">
                                <input type="radio" name="filterType" value="client" [checked]="filterType === 'client'"> Client
                            </label>
                        </div>
                    </div>
                    <div *ngIf="filterType === 'client'" class=" flex-grow-1 ml-5">
                        <div class="input-group input-group-sm" style="max-width: 200px;">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <select class="form-control form-select-sm" id="inputGroupSelect02" name="_pet_no" (change)="onPetChange($event)"
                                [(ngModel)]="searchTerm" required>
                                <option value="">All Pets</option>
                                <option [value]="item.pet_no" *ngFor="let item of petService.pets || []">
                                    {{ item.pet_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                 
                </div>
            </div>
        </div>
        <span *ngIf="(!filteredRecalls || filteredRecalls.length === 0) && !isLoading">No information available</span>
        <span *ngIf="isLoading" class="text-muted">Loading...</span>
        <div class="table-responsive max-h-500px">
            <table class="table table-bordered  table-sm rounded">
                <thead class="thead-light">
                    <tr>
                        <th *ngIf="filterType === 'client'">Pet</th>
                        <th>Note</th>
                        <th>Code</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of filteredRecalls || []">

                        <td *ngIf="filterType === 'client'">{{ item.pet_name }}</td>
                        <td>
                            <span class="text-hover-primary"
                                (click)="edit(item)">
                                {{ item.recall_note }}
                            </span>
                        </td>
                        <td>
                            {{ item.recall_code }}
                        </td>

                        <td>
                            {{ item.recall_date | date: 'MM/dd/yyyy' }}
                        </td>
                        <td>
                            <span *ngIf="!item.isEditing" 
                                  class="text-hover-primary cursor-pointer status-badge badge" 
                                  (click)="toggleEditStatus(item)"
                                  [ngClass]="getStatusClass(item.recall_status)">
                                {{ item.recall_statusdesc }}
                            </span>
                            <select *ngIf="item.isEditing && item.recall_status !== 'D'" 
                                    class="form-control form-control-sm" 
                                    [ngModel]="item.recall_status"
                                    (ngModelChange)="onStatusChange(item, $event)"
                                    (change)="closeDropdown(item)"
                                    (keydown.escape)="cancelEditStatus(item)"
                                    #statusSelect>
                                <option value="N">Pending</option>
                                <option value="A">Attempted</option>
                                <option value="C">Completed</option>
                                <option value="D" disabled>Deleted</option>
              
                            </select>
                        </td>
                        <td>
                            <button type="button" class="btn btn-icon btn-danger btn-sm btn-hover-danger my-0 mx-1" *ngIf="item.recall_status !== 'D'"
                            (click)="delete(item)">
                              <i class="la la-trash"></i>
                        </button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
</div>
</div>